module.exports = __webpack_public_path__ + "img/SC2-Disclaimer-2.e92cf8f0.svg";